import { SxProps, Theme } from "@mui/material/styles";

const ACCENT_PURPLE = "#7B49C1";
const ACCENT_PURPLE_LIGHT = "rgba(123, 73, 193, 0.08)";

export const resumeSectionStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
  minHeight: 0,
};

export const resumeListScrollStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
  maxHeight: 220,
  overflowY: "auto",
  overflowX: "hidden",
  pr: 0.5,
  WebkitOverflowScrolling: "touch",
};

export const resumeLabelStyles: SxProps<Theme> = (theme) => ({
  fontSize: "12px",
  fontWeight: 600,
  color: theme.palette.mode === "dark" ? "#D1D5DB" : "#374151",
});

export const resumeItemStyles: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  width: "100%",
  padding: "10px 12px",
  borderRadius: "10px",
  border: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.14)" : "#E5E7EB"
  }`,
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.04)" : "#FFFFFF",
});

export const resumeItemTextStyles: SxProps<Theme> = {
  minWidth: 0,
  flex: 1,
};

export const resumeTitleStyles: SxProps<Theme> = (theme) => ({
  fontSize: "13px",
  fontWeight: 600,
  color: theme.palette.mode === "dark" ? "#F9FAFB" : "#111827",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const resumeMetaStyles: SxProps<Theme> = {
  fontSize: "11px",
  color: "#9CA3AF",
};

export const continueButtonStyles: SxProps<Theme> = {
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: ACCENT_PURPLE,
  color: "#FFFFFF !important",
  whiteSpace: "nowrap",
  flexShrink: 0,
  "&:hover": {
    backgroundColor: "#6A3DA8",
    color: "#FFFFFF !important",
  },
};

export const dividerStyles: SxProps<Theme> = (theme) => ({
  border: "none",
  borderTop: `1px solid ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : "#E5E7EB"
  }`,
  my: 0.5,
});

export const loadingRowStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  py: 0.5,
};

export const emptyHintStyles: SxProps<Theme> = {
  fontSize: "12px",
  color: "#9CA3AF",
};

export const accentSurface = ACCENT_PURPLE_LIGHT;
